import React, { useState, useEffect } from 'react';
import { BellRing } from 'lucide-react';

const LiveWithdrawal = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const withdrawals = [
    // --- European / Western (60%) ---
    { id: 1, user: "Oliver**92", amount: "1450.00", time: "just now" },
    { id: 2, user: "Emma**Trade", amount: "89.50", time: "2 mins ago" },
    { id: 3, user: "Noah**7", amount: "2100.00", time: "5 mins ago" },
    { id: 4, user: "Sophia**", amount: "310.00", time: "just now" },
    { id: 5, user: "Lucas**88", amount: "125.00", time: "8 mins ago" },
    { id: 6, user: "Mia**Vip", amount: "2700.00", time: "10 mins ago" },
    { id: 7, user: "Liam**99", amount: "55.00", time: "1 min ago" },
    { id: 8, user: "Charlotte**", amount: "1200.00", time: "seconds ago" },
    { id: 9, user: "Ethan**Pro", amount: "940.00", time: "4 mins ago" },
    { id: 10, user: "Amelia**22", amount: "88.60", time: "7 mins ago" },
    { id: 11, user: "Jack**", amount: "410.00", time: "just now" },
    { id: 12, user: "Isabella**X", amount: "1100.00", time: "3 mins ago" },
    { id: 13, user: "Mason**9", amount: "25.00", time: "12 mins ago" },
    { id: 14, user: "Evelyn**80", amount: "950.00", time: "5 mins ago" },
    { id: 15, user: "Logan**", amount: "670.00", time: "9 mins ago" },
    { id: 16, user: "Harper**7", amount: "140.00", time: "just now" },
    { id: 17, user: "James**Pro", amount: "320.50", time: "2 mins ago" },
    { id: 18, user: "Lily**88", amount: "890.00", time: "4 mins ago" },
    { id: 19, user: "Benjamin**", amount: "45.00", time: "seconds ago" },
    { id: 20, user: "Ella**V", amount: "2100.00", time: "1 min ago" },
    { id: 21, user: "Alexander**9", amount: "135.00", time: "6 mins ago" },
    { id: 22, user: "Grace**77", amount: "480.00", time: "just now" },
    { id: 23, user: "Henry**", amount: "920.00", time: "8 mins ago" },
    { id: 24, user: "Chloe**12", amount: "35.00", time: "11 mins ago" },
    { id: 25, user: "Sebastian**", amount: "110.00", time: "3 mins ago" },
    { id: 26, user: "Aria**Vip", amount: "1550.00", time: "1 min ago" },
    { id: 27, user: "Daniel**5", amount: "240.00", time: "7 mins ago" },
    { id: 28, user: "Scarlett**", amount: "500.00", time: "just now" },
    { id: 29, user: "Matthew**99", amount: "65.00", time: "9 mins ago" },
    { id: 30, user: "Victoria**", amount: "1800.00", time: "4 mins ago" },
    { id: 31, user: "Samuel**7", amount: "290.00", time: "2 mins ago" },
    { id: 32, user: "Madison**", amount: "740.00", time: "just now" },
    { id: 33, user: "David**92", amount: "120.00", time: "8 mins ago" },
    { id: 34, user: "Luna**X", amount: "2200.00", time: "5 mins ago" },
    { id: 35, user: "Joseph**8", amount: "45.00", time: "seconds ago" },
    { id: 36, user: "Penelope**", amount: "950.00", time: "1 min ago" },
    { id: 37, user: "Carter**77", amount: "310.00", time: "10 mins ago" },
    { id: 38, user: "Layla**", amount: "140.00", time: "3 mins ago" },
    { id: 39, user: "Owen**Pro", amount: "880.00", time: "just now" },
    { id: 40, user: "Riley**9", amount: "55.00", time: "6 mins ago" },
    { id: 41, user: "Wyatt**", amount: "1250.00", time: "1 min ago" },
    { id: 42, user: "Zoey**88", amount: "90.00", time: "12 mins ago" },
    { id: 43, user: "John**", amount: "420.00", time: "4 mins ago" },
    { id: 44, user: "Nora**Vip", amount: "2600.00", time: "just now" },
    { id: 45, user: "Luke**1", amount: "115.00", time: "7 mins ago" },
    { id: 46, user: "Hannah**", amount: "780.00", time: "2 mins ago" },
    { id: 47, user: "Dylan**7", amount: "35.00", time: "9 mins ago" },
    { id: 48, user: "Mila**", amount: "1400.00", time: "5 mins ago" },
    { id: 49, user: "Isaac**99", amount: "210.00", time: "just now" },
    { id: 50, user: "Elizabeth**", amount: "650.00", time: "8 mins ago" },
    { id: 51, user: "Anthony**", amount: "125.00", time: "1 min ago" },
    { id: 52, user: "Stella**12", amount: "1900.00", time: "3 mins ago" },
    { id: 53, user: "Christopher**", amount: "80.00", time: "seconds ago" },
    { id: 54, user: "Maya**7", amount: "340.00", time: "11 mins ago" },
    { id: 55, user: "Joshua**88", amount: "1100.00", time: "just now" },
    { id: 56, user: "Paisley**", amount: "70.00", time: "4 mins ago" },
    { id: 57, user: "Andrew**Vip", amount: "520.00", time: "6 mins ago" },
    { id: 58, user: "Audrey**", amount: "2500.00", time: "2 mins ago" },
    { id: 59, user: "Gabriel**9", amount: "135.00", time: "9 mins ago" },
    { id: 60, user: "Skylar**", amount: "410.00", time: "just now" },
    { id: 61, user: "Julian**77", amount: "95.00", time: "5 mins ago" },
    { id: 62, user: "Violet**", amount: "880.00", time: "1 min ago" },
    { id: 63, user: "Ryan**X", amount: "230.00", time: "10 mins ago" },
    { id: 64, user: "Claire**", amount: "1200.00", time: "just now" },
    { id: 65, user: "Jaxon**1", amount: "45.00", time: "8 mins ago" },
    { id: 66, user: "Bella**", amount: "670.00", time: "3 mins ago" },
    { id: 67, user: "Levi**9", amount: "155.00", time: "seconds ago" },
    { id: 68, user: "Aurora**", amount: "1100.00", time: "7 mins ago" },
    { id: 69, user: "Christian**8", amount: "120.00", time: "just now" },
    { id: 70, user: "Lucy**", amount: "2400.00", time: "4 mins ago" },
    { id: 71, user: "Hunter**Vip", amount: "85.00", time: "6 mins ago" },
    { id: 72, user: "Anna**99", amount: "330.00", time: "2 mins ago" },
    { id: 73, user: "Jonathan**", amount: "710.00", time: "9 mins ago" },
    { id: 74, user: "Caroline**7", amount: "55.00", time: "just now" },
    { id: 75, user: "Aaron**", amount: "1450.00", time: "11 mins ago" },
    { id: 76, user: "Nova**X", amount: "260.00", time: "5 mins ago" },
    { id: 77, user: "Charles**", amount: "920.00", time: "just now" },
    { id: 78, user: "Genesis**9", amount: "115.00", time: "8 mins ago" },
    { id: 79, user: "Thomas**", amount: "1850.00", time: "1 min ago" },
    { id: 80, user: "Emilia**11", amount: "75.00", time: "seconds ago" },
    { id: 81, user: "Adrian**", amount: "430.00", time: "10 mins ago" },
    { id: 82, user: "Kennedy**Pro", amount: "1200.00", time: "just now" },
    { id: 83, user: "Nolan**8", amount: "65.00", time: "4 mins ago" },
    { id: 84, user: "Madeline**", amount: "2100.00", time: "7 mins ago" },
    { id: 85, user: "Jordan**77", amount: "190.00", time: "2 mins ago" },
    { id: 86, user: "Ruby**", amount: "780.00", time: "just now" },
    { id: 87, user: "Nicholas**", amount: "110.00", time: "6 mins ago" },
    { id: 88, user: "Serenity**9", amount: "1600.00", time: "9 mins ago" },
    { id: 89, user: "Ezra**", amount: "40.00", time: "seconds ago" },
    { id: 90, user: "Autumn**Vip", amount: "520.00", time: "3 mins ago" },

    // --- Asian (20%) ---
    { id: 91, user: "Yuki**Jp", amount: "1350.00", time: "just now" },
    { id: 92, user: "Chen**88", amount: "245.00", time: "5 mins ago" },
    { id: 93, user: "Wei**Trade", amount: "220.00", time: "11 mins ago" },
    { id: 94, user: "Sato**", amount: "940.00", time: "1 min ago" },
    { id: 95, user: "Priya**In", amount: "70.00", time: "8 mins ago" },
    { id: 96, user: "Minho**Kr", amount: "1100.00", time: "just now" },
    { id: 97, user: "Li**99", amount: "130.00", time: "10 mins ago" },
    { id: 98, user: "Haruto**", amount: "2700.00", time: "2 mins ago" },
    { id: 99, user: "Ananya**", amount: "55.00", time: "seconds ago" },
    { id: 100, user: "Jiwoo**8", amount: "410.00", time: "4 mins ago" },
    { id: 101, user: "Xian**", amount: "1250.00", time: "just now" },
    { id: 102, user: "Arjun**Vip", amount: "95.00", time: "7 mins ago" },
    { id: 103, user: "Mei**88", amount: "880.00", time: "9 mins ago" },
    { id: 104, user: "Thanh**Vn", amount: "160.00", time: "just now" },
    { id: 105, user: "Kim**", amount: "2400.00", time: "1 min ago" },
    { id: 106, user: "Rahul**In", amount: "45.00", time: "8 mins ago" },
    { id: 107, user: "Hina**", amount: "610.00", time: "5 mins ago" },
    { id: 108, user: "Akash**", amount: "115.00", time: "seconds ago" },
    { id: 109, user: "Yoon**Kr", amount: "1300.00", time: "10 mins ago" },
    { id: 110, user: "Zhang**", amount: "35.00", time: "just now" },
    { id: 111, user: "Rohan**8", amount: "890.00", time: "3 mins ago" },
    { id: 112, user: "Sora**", amount: "210.00", time: "6 mins ago" },
    { id: 113, user: "Linh**", amount: "1550.00", time: "just now" },
    { id: 114, user: "Kaito**Jp", amount: "75.00", time: "9 mins ago" },
    { id: 115, user: "Deepak**", amount: "420.00", time: "2 mins ago" },
    { id: 116, user: "Bao**Vn", amount: "1800.00", time: "just now" },
    { id: 117, user: "Sakura**", amount: "110.00", time: "4 mins ago" },
    { id: 118, user: "Tanveer**Pk", amount: "640.00", time: "7 mins ago" },
    { id: 119, user: "Ishaan**", amount: "95.00", time: "seconds ago" },
    { id: 120, user: "Ying**", amount: "1200.00", time: "11 mins ago" },

    // --- Arabic / Middle Eastern (20%) ---
    { id: 121, user: "Omar**Ae", amount: "230.00", time: "just now" },
    { id: 122, user: "Ahmed**Vip", amount: "940.00", time: "1 min ago" },
    { id: 123, user: "Fatima**", amount: "55.00", time: "8 mins ago" },
    { id: 124, user: "Zaid**99", amount: "1100.00", time: "just now" },
    { id: 125, user: "Hassan**", amount: "135.00", time: "5 mins ago" },
    { id: 126, user: "Youssef**Tr", amount: "2500.00", time: "10 mins ago" },
    { id: 127, user: "Amira**", amount: "80.00", time: "seconds ago" },
    { id: 128, user: "Mustafa**7", amount: "410.00", time: "3 mins ago" },
    { id: 129, user: "Noor**", amount: "1350.00", time: "just now" },
    { id: 130, user: "Ali**Invest", amount: "95.00", time: "6 mins ago" },
    { id: 131, user: "Hamza**", amount: "820.00", time: "9 mins ago" },
    { id: 132, user: "Sara**Ae", amount: "210.00", time: "just now" },
    { id: 133, user: "Khalid**", amount: "1900.00", time: "2 mins ago" },
    { id: 134, user: "Laila**", amount: "45.00", time: "12 mins ago" },
    { id: 135, user: "Ibrahim**", amount: "530.00", time: "1 min ago" },
    { id: 136, user: "Mariam**", amount: "1100.00", time: "just now" },
    { id: 137, user: "Sultan**Vip", amount: "65.00", time: "7 mins ago" },
    { id: 138, user: "Farrah**", amount: "1450.00", time: "4 mins ago" },
    { id: 139, user: "Malik**88", amount: "260.00", time: "seconds ago" },
    { id: 140, user: "Tariq**", amount: "920.00", time: "just now" },
    { id: 141, user: "Hoda**", amount: "115.00", time: "8 mins ago" },
    { id: 142, user: "Habib**", amount: "1850.00", time: "11 mins ago" },
    { id: 143, user: "Rania**", amount: "75.00", time: "2 mins ago" },
    { id: 144, user: "Adnan**", amount: "1200.00", time: "just now" },
    { id: 145, user: "Yasmin**", amount: "330.00", time: "5 mins ago" },
    { id: 146, user: "Karim**99", amount: "710.00", time: "10 mins ago" },
    { id: 147, user: "Salma**", amount: "55.00", time: "seconds ago" },
    { id: 148, user: "Faisal**", amount: "1400.00", time: "1 min ago" },
    { id: 149, user: "Dina**", amount: "210.00", time: "just now" },
    { id: 150, user: "Bashir**", amount: "650.00", time: "9 mins ago" },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % withdrawals.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [withdrawals.length]);

  const styles = {
    wrapper: {
      width: '100%',
      padding: '0 15px', 
      margin: '10px 0',
      display: 'flex',
      justifyContent: 'flex-start',
      boxSizing: 'border-box',
    },
    card: {
      width: '100%',
      height: '40px',
      background: 'linear-gradient(90deg, #0d121d 0%, #161d2b 100%)',
      borderRadius: '15px', 
      border: '1px solid rgba(243, 186, 47, 0.25)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '0 12px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
      overflow: 'hidden',
    },
    iconBox: {
      marginRight: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    textContainer: {
      flex: 1,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
    },
    userTag: { color: '#f3ba2f', fontWeight: '600', fontSize: '12px', marginRight: '5px' },
    actionTag: { color: '#ffffff', fontSize: '11px', opacity: '0.7', marginRight: '5px' },
    amountTag: { color: '#2ebd85', fontWeight: '700', fontSize: '12px' },
    timeTag: { color: '#555', fontSize: '10px', marginLeft: 'auto' }
  };

  return (
    <div style={styles.wrapper}>
      <style>
        {`
          @keyframes slideUpWithdrawal {
            0% { transform: translateY(15px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          .animate-withdrawal {
            display: flex;
            align-items: center;
            width: 100%;
            animation: slideUpWithdrawal 0.5s ease-out;
            justify-content: flex-start;
          }
          .bell-swing {
            animation: swing 2s infinite;
          }
          @keyframes swing {
            0%, 100% { transform: rotate(0); }
            20% { transform: rotate(15deg); }
            40% { transform: rotate(-15deg); }
            60% { transform: rotate(10deg); }
            80% { transform: rotate(-10deg); }
          }
        `}
      </style>
      <div style={styles.card}>
        <div style={styles.iconBox}>
          <BellRing size={15} color="#f3ba2f" className="bell-swing" />
        </div>
        <div style={styles.textContainer}>
          <div key={currentIndex} className="animate-withdrawal">
             <span style={styles.userTag}>{withdrawals[currentIndex].user}</span>
             <span style={styles.actionTag}>withdrawn</span>
             <span style={styles.amountTag}>${withdrawals[currentIndex].amount}</span>
             <span style={styles.timeTag}>{withdrawals[currentIndex].time}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveWithdrawal;